import { SELECIONAR_PESSOA_CONTRATANTE } from '../types'

export default function selecionarPessoaContratante (pessoa) {
  return {
    type: SELECIONAR_PESSOA_CONTRATANTE,
    payload: pessoa
  }
}
